<app-nav-fab-menu></app-nav-fab-menu>
<ngx-spinner
  bdOpacity="0.9"
  [bdColor]="'rgba(51,51,51,0.2)'"
  [size]="'medium'"
  [color]="'#b41919'"
  [type]="'square-loader'"
  [fullScreen]="true">
</ngx-spinner>

<router-outlet></router-outlet>
